<template>
  <div class="timeline">
    <div v-if="mergedOptions.showMarkers">
      <div v-for="(d, index) in data" :key="index">
        <div class="circle">{{ d.marker }}</div>
        <div class="connection">
          <div class="vertical-line"></div>
          <div>
            <div :ref="index" class="point" v-for="text in d.texts" :key="text">
              <div class="textbox">{{ text }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!mergedOptions.showMarkers">
      <div class="startPoint"></div>
      <div class="wrapper">
        <div v-for="(d, index) in data" :key="index" class="connection-wrapper">
          <div class="connection">

            <div class="vertical-line"></div>
            <div>
              <div :ref="index + '_' + i" class="point" v-for="(text, i) in d.texts" :key="text">
                <div v-if="mergedOptions.showMarkersOnLeft" class="leftMarker">{{ d.marker }}</div>
                <div class="textbox" :class="[mergedOptions.textBoxStyle]" v-html="text"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="endPoint"><div class="vertical-line"></div></div>
    </div>
    <!-- <div>
            <div class="circle"> 2005 </div>
            <div class="connection">
                <div class="vertical-line"></div>
                    <div ref="3">
                    <div class="textbox"> Here comes my text</div>
                </div>
            </div>
    </div>-->
  </div>
</template>

<script>
export default {
  name: 'Timeline',
  props: {
    data: Array,
    options: {
      type: Object,
      default: () => ({}),
      required: false
    }
  },
  data () {
    return {
      marginTop: 0,
      mergedOptions: {},
      defaultOptions: {
        showMarkers: true,
        showMarkersOnLeft: false,
        withoutTextContainer: false,
        textBoxStyle: 'default'
      }
    }
  },
  created () {
    this.setOptions()
    console.log(this.$refs)
    // this.setAnimations()
  },
  mounted () {
    this.setAnimations()
  },
  methods: {
    setOptions () {
      const d = this.defaultOptions
      const o = this.options
      this.mergedOptions = assignObject(o, d)
      function assignObject (a, b) {
        let m = {}
        Object.keys(b).forEach(key => {
          if (typeof a[key] === 'object' && a[key] !== null) {
            console.log('>>>>>>', a[key], b[key])
            m[key] = assignObject(a[key], b[key])
          } else if (a[key] && a[key].isArray && a[key].length > 1) {
            m[key] = assignArray(a[key], b[key])
          } else if (typeof a[key] === 'undefined') {
            m[key] = b[key]
          } else {
            m[key] = a[key]
          }
        })
        return m
      }
      function assignArray (a, b) {
        let m = {}
        b.forEach((key, value) => {
          if (typeof a[key] === 'object' && a[key] !== null) {
            m[key] = assignObject(a[key], b[key])
          } else if (a[key] && a[key].isArray && a[key].length > 1) {
            m[key] = assignArray(a[key], b[key])
          } else if (typeof a[key] === 'undefined') {
            m[key] = b[key]
          } else {
            m[key] = a[key]
          }
        })
        return m
      }
    },
    setAnimations () {
      let delay = 0.3
      Object.keys(this.$refs).forEach(key => {
        // Code for Safari 4.0 - 8.0
        this.$refs[key][0].style.WebkitAnimation =
          'fadeIn .5s ' + delay + 's ease-in 1 forwards'
        // Standard syntax
        this.$refs[key][0].style.animation =
          'fadeIn .5s ' + delay + 's ease-in 1 forwards'
        delay += 0.3
      })
    }
  }
}
</script>

<style lang="scss">
.timeline {
  margin: 65px 0 0 50px;
  @-webkit-keyframes fadeIn {
    to {
      opacity: 1;
    }
  }

  @keyframes fadeIn {
    to {
      opacity: 1;
    }
  }
  .circle {
    height: 50px;
    border-radius: 50%;
    width: 50px;
    border: 3px solid black;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .point {
    position: relative;
    opacity: 0;
    &:before {
      content: " ";
      border: 1px solid black;
      border-radius: 50%;
      width: 14px;
      height: 14px;
      position: absolute;
      top: 22px;
      left: -10px;
      background-color: black;
    }
    .leftMarker {
      position: absolute;
      left: -80px;
      margin-top: 20px;
      width: 60px;
    }
  }
  .vertical-line {
    width: 0;
    border-left: 4px solid black;
    margin-left: 26px;
  }
  .startPoint,
  .endPoint {
    position: relative;
    &:after {
      content: " ";
      // border: 1px solid black;
      border-radius: 50%;
      width: 28px;
      height: 28px;
      position: absolute;
      left: 14px;
      background-color: black;
    }
    .vertical-line {
      height: 20px;
    }
  }
  .startPoint {
    top: -28px;
  }
  .connection {
    display: flex;

  }
  .textbox {
    margin-left: 55px;
    margin-bottom: 20px;
    padding: 20px;
    position: relative;
    &.default {
      border-radius: 2px;
      border: 1px solid #d4d4d4;
      box-shadow: 0 1px 2px rgba(100, 100, 100, 0.2);
      &:before {
        border-bottom: 15px solid transparent;
        border-left: 0 solid #ccc;
        border-right: 15px solid #ccc;
        border-top: 15px solid transparent;
        content: " ";
        display: inline-block;
        position: absolute;
        left: -15px;
        right: auto;
        top: 15px;
      }
      &:after {
        border-bottom: 14px solid transparent;
        border-left: 0 solid #fff;
        border-right: 14px solid #fff;
        border-top: 14px solid transparent;
        content: " ";
        display: inline-block;
        position: absolute;
        left: -14px;
        right: auto;
        top: 16px;
      }
    }
    &.simple {
      margin-left: 10px;
      margin-bottom: 0;
      padding: 20px 10px 0 20px;
    }
  }
}
</style>
